/**
 * Chip — пилюля-переключатель (вид отпуска/причина/город в processes.tsx,
 * ChannelPill в news.tsx, чип-ряд OptionSelect). Раньше копипастилась инлайн
 * 4+ раза — здесь единая реализация 1:1 по визуалу с оригиналами.
 *
 * dim=true — приглушённый бордер ($borderColor) вместо акцентного $primary,
 * когда в группе уже выбрано что-то ДРУГОЕ (см. было в RecPill/OptionSelect:
 * dim = anySelected && !on). dim не задан/false — off-чип держит $primary
 * бордер как приглашение выбрать (кейсы без этой логики просто не передают dim).
 */
import type { ReactNode } from 'react'
import { Text, XStack, type GetProps } from 'tamagui'

import { pressable } from './primitives'

export function Chip({
  on,
  dim,
  children,
  onPress,
  ...rest
}: {
  on: boolean
  dim?: boolean
  children: ReactNode
  onPress: () => void
} & GetProps<typeof XStack>) {
  return (
    <XStack
      {...pressable}
      onPress={onPress}
      cursor="pointer"
      paddingHorizontal={13}
      paddingVertical={7}
      borderRadius={999}
      borderWidth={1}
      backgroundColor={on ? '$primary' : '$background'}
      borderColor={on ? '$primary' : dim ? '$borderColor' : '$primary'}
      // Длинная подпись («AS Group Investment MMC · General Director · основное» на телефоне)
      // переносится внутри пилюли, а не вылезает за карточку (замечание 30.10.2026).
      maxWidth="100%"
      // aria-pressed не существует в типах RN/Tamagui (только aria-selected) —
      // ближайший валидный эквивалент состояния "выбрано" (см. память Tamagui a11y).
      aria-selected={on}
      {...rest}
    >
      <Text flexShrink={1} fontSize={13} fontWeight="600" color={on ? '$onPrimary' : dim ? '$muted' : '$primary'}>
        {children}
      </Text>
    </XStack>
  )
}
